import { useParams, useSearchParams } from "react-router";
import SurveyForm from "../../components/SurveyForm";
import { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../../components/Loader";
const SurveyFormPage = () => {
  const [data, setData] = useState({});
  const [error, setError] = useState(null);
  const { surveyId } = useParams();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("user_id");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!surveyId) return;
    setLoading(true);
    axios
      .get(
        `https://pulse.upstartaec.com/agent/survey-form/${surveyId}?user_id=${userId}`
      )
      .then((res) => {
        console.log("API Response:", res);
        console.log("Response Data:", res.data);
        
        // Validate response structure
        if (res.data && res.data.success && res.data.data) {
          setData(res.data);
          setError(null); // Clear any previous errors
        } else {
          console.error("Invalid response structure:", res.data);
          setError({
            type: "error",
            message: "Invalid response from server. Please try again later."
          });
        }
      })
      .catch((err) => {
        console.log("Err", err);
        console.log("Error details:", {
          message: err.message,
          response: err.response,
          status: err.response?.status,
          data: err.response?.data
        });
        
        // Handle network errors (CORS, connection issues, etc.)
        if (err.code === 'ERR_NETWORK' || err.message === 'Network Error' || !err.response) {
          setError({
            type: "error",
            message: "Network error. Please check your connection or contact support if the issue persists."
          });
          return;
        }
        
        // Handle survey expiration (410 status)
        if (err.response?.status === 410) {
          setError({
            type: "expired",
            message: err.response.data.detail || "Survey has expired and is no longer available"
          });
        } else if (err.response?.status === 404) {
          setError({
            type: "error",
            message: "Survey not found. Please check the survey link and try again."
          });
        } else if (err.response?.status >= 500) {
          setError({
            type: "error",
            message: "Server error. Please try again later or contact support."
          });
        } else {
          setError({
            type: "error",
            message: err.response?.data?.message || err.response?.data?.detail || "Failed to load survey. Please try again later."
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [surveyId, userId]);
  useEffect(() => {
    console.log("Data", data);
  }, [data]);
  if (loading) return <Loader />;
  
  // Show expired survey message
  if (error?.type === "expired") {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center p-6">
        <div className="max-w-md mx-auto text-center">
          <div className="w-20 h-20 bg-gradient-to-r from-red-500 to-pink-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-2xl">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Survey Expired</h1>
          <p className="text-lg text-gray-600 mb-6 leading-relaxed">
            {error.message}
          </p>
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <div className="flex items-center">
              <svg className="w-5 h-5 text-yellow-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
              <span className="text-sm text-yellow-800">
                Surveys expire after 24 hours or when completed
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <p className="text-sm text-gray-500">
              If you believe this is an error, please contact the survey administrator.
            </p>
            <p className="text-sm text-gray-500">
              You may need to request a new survey link.
            </p>
          </div>
        </div>
      </div>
    );
  }
  
  // Show general error message
  if (error?.type === "error") {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center p-6">
        <div className="max-w-md mx-auto text-center">
          <div className="w-20 h-20 bg-gradient-to-r from-red-500 to-pink-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-2xl">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Unable to Load Survey</h1>
          <p className="text-lg text-gray-600 mb-6 leading-relaxed">
            {error.message}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105"
          >
            <svg className="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Try Again
          </button>
        </div>
      </div>
    );
  }
  
  // Ensure data exists and has the required structure before rendering
  if (!data || !data.data || !data.data.questions) {
    return <Loader />;
  }
  
  return <SurveyForm surveyData={data} />;
};

export default SurveyFormPage;
